import { atom, selector } from 'recoil'

import type { ModalPendingState } from 'Pages/RecipientsList/model'

export const modalPendingState = atom<ModalPendingState>({
  key: 'recipientsList_modalPendingState',
  default: {
    show: false,
    idRecipient: 0,
    contact: '',
    idConfirmationMessage: 0,
    idConfirmationMessageIsDirty: false,
  },
})

export const modalPendingHasMessageFeedback = selector<boolean>({
  key: 'recipientsList_modalPendingHasMessageFeedback',
  get: ({ get }) => {
    const { idConfirmationMessage, idConfirmationMessageIsDirty } =
      get(modalPendingState)

    return (
      (idConfirmationMessage === undefined || idConfirmationMessage === null) &&
      idConfirmationMessageIsDirty
    )
  },
})

export const modalPendingSubmitDisabledState = selector<boolean>({
  key: 'recipientsList_modalPendingSubmitDisabledState',
  get: ({ get }) => {
    const { idConfirmationMessage, idRecipient } = get(modalPendingState)

    return !(idConfirmationMessage > 0 && idRecipient > 0)
  },
})
